import * as types from '../constants/AuthActionTypes';


export const setUser = (user, isAuthenticated, email_verified) => {
  return {
    type: types.AUTH_SET_USER,
    user,
    isAuthenticated,
    email_verified
  }
}


